import { Directive, ElementRef } from '@angular/core';

@Directive({
	selector: 'form input',
	standalone: true
})
export class FormDndValidateDirective {
	constructor(el: ElementRef) {
		const htmlEl: HTMLInputElement = el.nativeElement;
		htmlEl.addEventListener('drop', ev => {
			setTimeout(_ => htmlEl.dispatchEvent(new Event('change')), 200)
			return ev;
		})
	}
}
